function DescriptionListHeader({ children }) {
  return (
    <span className="font-bold text-14/20 md:text-16/24 text-black-primary">
      {children}
    </span>
  );
}

export { DescriptionListHeader };
